import { useState } from 'react';
import { fetchBudgetHistory } from '../../../../../api/fetchBudget';
import { Budget, BudgetHistory } from '../../../types';
import { SortDirection, SortField } from '../../../utils/sortUtils';
import BudgetRow from './BudgetRow';
import BudgetsTableHeader from './BudgetsTableHeader';

import { BudgetRecipientEnum } from '../../../createAndEdit/types';

interface IBudgetsTableProps {
  budgets: Budget[];
  occurrenceId: string;
  onViewBudget: (budgetId: string, versionNumber?: number) => void;
  onEditBudget?: (budgetId: string, versionNumber?: number) => void;
  sortField: SortField | null;
  sortDirection: SortDirection;
  onSort: (field: SortField) => void;
  userProfile?: BudgetRecipientEnum | string;
}

const BudgetsTable = (props: IBudgetsTableProps) => {
  const [expandedRows, setExpandedRows] = useState<Set<string>>(new Set());
  const [budgetsHistory, setBudgetsHistory] = useState<Record<string, BudgetHistory[]>>({});
  const [loadingHistory, setLoadingHistory] = useState<Record<string, boolean>>({});

  const toggleRow = async (budgetId: string) => {
    const newExpanded = new Set(expandedRows);
    const wasExpanded = newExpanded.has(budgetId);

    if (wasExpanded) {
      newExpanded.delete(budgetId);
    } else {
      newExpanded.add(budgetId);

      if (!budgetsHistory[budgetId] && !loadingHistory[budgetId]) {
        setLoadingHistory((prev) => ({ ...prev, [budgetId]: true }));
        try {
          const { data: history } = await fetchBudgetHistory(
            budgetId,
            'versionNumber',
            'desc',
            1,
            50,
          );
          setBudgetsHistory((prev) => ({ ...prev, [budgetId]: history }));
        } catch (error) {
        } finally {
          setLoadingHistory((prev) => ({ ...prev, [budgetId]: false }));
        }
      }
    }
    setExpandedRows(newExpanded);
  };

  return (
    <div className="mb-8">
      <table className="table table-column-overflow-hidden table-bordered table-head-filled">
        <BudgetsTableHeader
          sortField={props.sortField}
          sortDirection={props.sortDirection}
          onSort={props.onSort}
        />
        <tbody>
          {props.budgets.map((budget) => {
            const isExpanded = expandedRows.has(budget.id);
            const hasHistory = budget.hasHistory === true;
            const history = budgetsHistory[budget.id] || [];
            const isLoading = loadingHistory[budget.id] === true;

            return (
              <BudgetRow
                key={budget.id}
                budget={budget}
                isExpanded={isExpanded}
                hasHistory={hasHistory}
                history={history}
                isLoading={isLoading}
                onToggleRow={toggleRow}
                onViewBudget={props.onViewBudget}
                onEditBudget={props.onEditBudget}
                userProfile={props.userProfile}
              />
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default BudgetsTable;

